<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            <p>
                ECHOLOT wurde nach der Bundesgartenschau als Teil des Nachhaltigkeitskonzepts auf dem Campus der Hochschule in Koblenz wiederaufgebaut und wird dort seit 2011 dauerhaft genutzt.
            </p>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(3)"
            :link="links[3]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(6)"
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="mt-5">
            <span class="font-semibold">Entwurf und Realisierung</span><br />
            <p class="leading-tight">
                Prof. Dr.-Ing. Manfred Feyerabend<br />
                Prof. Dr.-Ing. Markus Holzbach<br />
                Jennifer B&ouml;hm B.A., Simon G&ouml;rgen, Raunahi Hamo, Andreas Meister, Constantin M&uuml;ller B.A., Kristina M&uuml;lligann B.A., Natalie M&uuml;nch B.A., Alexander Schumann, Chao Yang.<br />
                <br />
                <span class="font-semibold">Planung Licht und Ton</span><br />
                Prof. Dr. Jens Bongartz<br />
                Dipl.-Ing. Alexander Jenal M. Sc.<br />
                Thomas Giese<br />
                Martin Krings<br />
                <br />
                <span class="font-semibold">Projekt Hochschule Koblenz</span><br />
                Bauherr.<br />
                Fachhochschule Koblenz, Konrad-Zuse-Str. 1, 56075 Koblenz<br />
                Datum der Fertigstellung<br />
                M&auml;rz 2011<br />
            </p>
        </div>
    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/2012-09-06 (FF 21) Montage Holzelemente.jpg' ),
                require( '@/assets/img/pc/2012-09-06 (FF 02) Montage Holzelemente.jpg' ),
                require( '@/assets/img/pc/2012-09-06 (FF 15) Montage Holzelemente.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>